document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-free-shipping-add]');
  if (!button) return;

  event.preventDefault();
  if (button.getAttribute('aria-disabled') === 'true') return;

  const cartDrawer = document.querySelector('cart-drawer');
  const variantId = button.dataset.variantId;
  if (!variantId || !cartDrawer) return;

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  formData.append(
    'sections',
    cartDrawer.getSectionsToRender().map((section) => section.id)
  );
  formData.append('sections_url', window.location.pathname);
  cartDrawer.setActiveElement(document.activeElement);
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.error(response.description || response.message);
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'free-shipping-bar',
        productVariantId: variantId,
        cartData: response,
      });

      cartDrawer.renderContents(response);
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    });
});
